import * as Combobox from '@givebutter/primitives/combobox';

const PlanStatusOptions = () => (
    <>
        <Combobox.Item value="active">
            <Combobox.CheckboxIndicator />
            <Combobox.ItemText>Active</Combobox.ItemText>
        </Combobox.Item>
        <Combobox.Item value="paused">
            <Combobox.CheckboxIndicator />
            <Combobox.ItemText>Paused</Combobox.ItemText>
        </Combobox.Item>
        <Combobox.Item value="paused_temporarily">
            <Combobox.CheckboxIndicator />
            <Combobox.ItemText>Paused Temporarily</Combobox.ItemText>
        </Combobox.Item>
        <Combobox.Item value="disputed">
            <Combobox.CheckboxIndicator />
            <Combobox.ItemText>Disputed</Combobox.ItemText>
        </Combobox.Item>
        <Combobox.Item value="cancelled">
            <Combobox.CheckboxIndicator />
            <Combobox.ItemText>Cancelled</Combobox.ItemText>
        </Combobox.Item>
        <Combobox.Item value="past_due">
            <Combobox.CheckboxIndicator />
            <Combobox.ItemText>Past Due</Combobox.ItemText>
        </Combobox.Item>
    </>
);

export { PlanStatusOptions };
